var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"rpb",class:[`rpb-${_vm.visualState}`, { 'rpb-compact': _vm.compact }],attrs:{"disabled":_vm.loading,"title":_vm.tooltip,"type":"button"},on:{"click":function($event){return _vm.$emit('refresh')}}},[_c('i',{staticClass:"fa",class:_vm.iconClass}),_c('span',{staticClass:"rpb-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }